import * as Yup from 'yup';

export const initialValues = {
    identityAndRole: [
        { title: 'Nombre', description: '' },
        { title: 'Rol', description: '' },
        { title: 'Postura', description: '' },
        { title: 'Modelo Conversacional', description: '' },
    ],
};

export const validationSchema = Yup.object().shape({
    identityAndRole: Yup.array().of(
        Yup.object().shape({
            title: Yup.string().required('Requerido'),
            description: Yup.string().required('Requerido'),
        })
    ),
});
